if (!customElements.get('product-form')) {
  customElements.define('product-form', class ProductForm extends HTMLElement {
    constructor() {
      super();

      this.form = this.querySelector('form');
      this.form.querySelector('[name=id]').disabled = false;
      this.form.addEventListener('submit', this.onSubmitHandler.bind(this));
      this.cart = document.querySelector('cart-drawer');
      this.submitButton = this.querySelector('[type="submit"]');
      if (document.querySelector('cart-drawer') && this.submitButton) this.submitButton.setAttribute('aria-haspopup', 'dialog');

      this.hideErrors = this.dataset.hideErrors === 'true';
    }

    onSubmitHandler(evt) {
      evt.preventDefault();
      const product__outer = this.closest('.product__outer');
      let return_not_selected = false;
      if (this.submitButton.getAttribute('aria-disabled') === 'true') return;
      if ( product__outer.querySelectorAll('[data-not-selected="true"]:not([data-length-feature])').length > 0 ){
        product__outer.querySelectorAll('.select-selected[data-not-selected="true"]:not([data-length-feature]), [data-not-selected="true"]:not([data-length-feature]) .pricing-option').forEach(function (ele) {
          const error_ele = ele.closest('fieldset') ? ele.closest('fieldset').querySelector('.varient-error-message') : null;
          if( error_ele ){
            error_ele.classList.remove('hide');
          }
        });
        return_not_selected = true;
      }
      if ( product__outer.querySelectorAll('.quantity-box.length-active fieldset .select-selected.not-active').length > 0 ){

        product__outer.querySelectorAll('.quantity-box.length-active fieldset .select-selected.not-active').forEach(function (ele) {
          const error_ele = ele.closest('.fieldset_qty--wrapper') ? ele.closest('.fieldset_qty--wrapper').querySelector('.varient-error-message') : null;
          if( error_ele ){
            error_ele.classList.remove('hide');
          }
        });
        return_not_selected = true;
      }

      if( return_not_selected ) return;

      const variant_metafields =  product__outer.closest('.main-product').querySelector('[json-variant-metafields]') ?
      JSON.parse(product__outer.closest('.main-product').querySelector('[json-variant-metafields]').innerHTML) : null;      

      /* For the giftcard  */
      const giftCheckbox = document.querySelector('input[name="properties[__shopify_send_gift_card_to_recipient]"]');
      let giftFormValidate = true;
      if( giftCheckbox && giftCheckbox.checked ){        
        giftFormValidate = giftcardRecipient();
      }
      if( !giftFormValidate ) return;
      /* For the giftcard  */      

      const items = [], items_object = {}, multi_vari_eles = product__outer.querySelectorAll('.quantity-box.length-active .fieldset_qty--wrapper[data-variant-id]');     

      this.handleErrorMessage();

      this.submitButton.setAttribute('aria-disabled', true);
      this.submitButton.classList.add('loading');
      this.querySelector('.loading-overlay__spinner').classList.remove('hidden');

      const config = fetchConfig('javascript');
      config.headers['X-Requested-With'] = 'XMLHttpRequest';
      delete config.headers['Content-Type'];

      const formData = new FormData(this.form);
      if (this.cart) {
        formData.append('sections', this.cart.getSectionsToRender().map((section) => section.id));
        formData.append('sections_url', window.location.pathname);
        this.cart.setActiveElement(document.activeElement);
      }
      config.body = formData;
      const quantity = Number(formData.get('quantity') || 1);      
      
      if( multi_vari_eles.length > 0 ){
        let multi_vari_ids = [];
        multi_vari_eles.forEach((ele)=>{
          multi_vari_ids.push(ele.dataset.variantId);
        })
                
        for (const pair of formData.entries()) {
          let key = pair[0];
          var properties = {};
          if( key.indexOf('properties') > -1 ){
            key = key.split('properties[')[1].replace(']','');
            if( key != 'timestamp' ||  key != '_max-qty' ||  key != '_min-qty' ){
              properties.properties[key] = pair[1];
            }
          }          
        }

        if( multi_vari_ids.length ){
          const ele_this = this, unique_vari_ids = [...new Set(multi_vari_ids)];
          fetch('/cart.js')
          .then(response => {
            if (!response.ok) throw new Error('Network response was not ok');
            return response.json();
          })
          .then(cart => {
            console.log('Cart:', cart, unique_vari_ids);
            const cartQuantities = {};
            let prevent_add = false;
            cart.items.forEach(item => {
              const variantId = item.variant_id;
              cartQuantities[variantId] = (cartQuantities[variantId] || 0) + item.quantity;
            });            
            product__outer.querySelectorAll('.error-message-qty').forEach((ele)=>{ ele.innerHTML= ''; ele.classList.add('hide'); })
            if( Object.entries(cartQuantities).length > 0 ){              
              unique_vari_ids.forEach(( vari_id )=>{
                var total_qty = 0;
                const v_title = variant_metafields != null ? variant_metafields[vari_id].title : vari_id;
                const single_selector = product__outer.querySelector('.quantity-box.length-active .fieldset_qty--wrapper[data-variant-id="'+vari_id+'"]');
                const qty_box_ele = single_selector.closest('.quantity-box');
                var has_max_qty = single_selector.dataset.maxQty != null ? Number(single_selector.dataset.maxQty) : null;
                const vari_input_eles = product__outer.querySelectorAll('.quantity-box.length-active .fieldset_qty--wrapper[data-variant-id="'+vari_id+'"]')
                vari_input_eles.forEach((ele)=>{
                  total_qty = total_qty + Number(ele.querySelector('.quantity__input').value);
                });

                if( has_max_qty != null ){                  
                  var cart_total_qty = total_qty + cartQuantities[vari_id];
                  if( total_qty > has_max_qty ){
                    qty_box_ele.querySelector('.error-message-qty').innerHTML += `<div class="_${vari_id}">You can not add more than ${has_max_qty}, for the <b>${v_title}</b>.</div>`;
                    if ( cartQuantities[vari_id] ){
                      qty_box_ele.querySelector('.error-message-qty ._'+vari_id).innerHTML += ` And your cart have already ${cartQuantities[vari_id]} quantity for the <b>${v_title}</b>.`;
                    }
                    qty_box_ele.querySelector('.error-message').classList.remove('hide');
                    qty_box_ele.querySelector('.error-message-qty').classList.remove('hide');
                    prevent_add = true;
                  }
                  if( cart_total_qty > has_max_qty ){
                    const d = cartQuantities[vari_id] < has_max_qty ? (has_max_qty - cartQuantities[vari_id]) : (has_max_qty + 1);                    
                    if( d <= has_max_qty ){
                      qty_box_ele.querySelector('.error-message-qty').innerHTML += `<div class="_${vari_id}"> You can only add upto <b>${d}</b> quantity for <b>${v_title}</b>.`;
                    }else{
                      qty_box_ele.querySelector('.error-message-qty').innerHTML += `<div class="_${vari_id}"> In your cart already have ${cartQuantities[vari_id]} quantity. you can't add more than ${has_max_qty} for <b>${v_title}</b>.`;
                      qty_box_ele.querySelector('.error-message').classList.remove('hide');
                    }
                    qty_box_ele.querySelector('.error-message-qty').classList.remove('hide');                    

                    const diff = cart_total_qty - has_max_qty;
                    var loop_breaked = false;
                    for( let i = (vari_input_eles.length-1); i > 0; i-- ){
                      let in_value = Number(vari_input_eles[i].querySelector('.quantity__input').value);
                      if( in_value > diff ){
                        vari_input_eles[i].querySelector('.quantity__input').value = in_value - diff;
                        loop_breaked = true;
                        break;
                      }
                    }
                    // if( !loop_breaked ){
                    //   for( let i = (vari_input_eles.length-1); i > -1; i-- ){
                    //     let in_value = Number(vari_input_eles[i].querySelector('.quantity__input').value);
                    //     if( in_value < diff ){
                    //       vari_input_eles[i].querySelector('.quantity__input').value = in_value - (diff - in_value);
                    //       loop_breaked = true;
                    //       break;
                    //     }
                    //   }
                    // }  
                    
                    console.log('has_max_qty, cart_total_qty, total_qty, diff, total_qty - diff');
                    console.log(has_max_qty, cart_total_qty, total_qty, diff, total_qty - diff);
                    prevent_add = true;
                  }
                }
              })
            }else{
              unique_vari_ids.forEach(( vari_id )=>{
                var total_qty = 0;
                const v_title = variant_metafields != null ? variant_metafields[vari_id].title : vari_id;
                const single_selector = product__outer.querySelector('.quantity-box.length-active .fieldset_qty--wrapper[data-variant-id="'+vari_id+'"]');
                const qty_box_ele = single_selector.closest('.quantity-box');
                var has_max_qty = single_selector.dataset.maxQty != null ? Number(single_selector.dataset.maxQty) : null;
                const vari_input_eles = product__outer.querySelectorAll('.quantity-box.length-active .fieldset_qty--wrapper[data-variant-id="'+vari_id+'"]')

                vari_input_eles.forEach((ele)=>{
                  total_qty = total_qty + Number(ele.querySelector('.quantity__input').value);
                });
                
                if( has_max_qty != null ){                  
                  if( total_qty > has_max_qty ){
                    qty_box_ele.querySelector('.error-message-qty').innerHTML += `<div class="_${vari_id}">You can not add more than ${has_max_qty}, for the <b>${v_title}</b>.</div>`;
                    qty_box_ele.querySelector('.error-message').classList.remove('hide');
                    qty_box_ele.querySelector('.error-message-qty').classList.remove('hide');
                    prevent_add = true;
                  }
                }
              })

            }
            if( prevent_add ){
              ele_this.submitButton.classList.remove('loading');              
              ele_this.submitButton.removeAttribute('aria-disabled');
              ele_this.querySelector('.loading-overlay__spinner').classList.add('hidden');
            }else{
              createItem(ele_this, unique_vari_ids, items_object, properties);
            }
          })
          .catch(error => {
            console.error('Fetch error:', error);
          });
        }
        // items_object['items'] = items;
        // if (this.cart) {
        //   items_object['sections'] = this.cart.getSectionsToRender().map((section) => section.id);
        //   items_object['sections_url'] = window.location.pathname;          
        // }
        // console.log('items', items);
        //callMainAddtoCart(this, formData, config, items_object);
        return;
      }else{
        for (const pair of formData.entries()) {
          let key = pair[0];        
          if( key == "id" && variant_metafields && variant_metafields[pair[1]] ){
            if( variant_metafields[pair[1]].max_qunatity != null ){
              formData.append('properties[_max-qty]', Number(variant_metafields[pair[1]].max_qunatity));              
            }
            if( variant_metafields[pair[1]].min_qunatity != null ){
              formData.append('properties[_min-qty]', Number(variant_metafields[pair[1]].min_qunatity));
            }
            const timestamp = Date.now();            
            formData.append('properties[_timestamp]', Number(timestamp));
          }
        }
      }

      callMainAddtoCart(this, formData, config, items_object);
      console.log('items_object items_object', items_object);      

      function callMainAddtoCart (ele_this, ele_formData, config, ele_items){

        if( Object.entries(ele_items).length > 0 ){
          config.headers['Content-Type'] = 'application/json';
          config.headers['Accept'] = 'application/json';
          config.body = JSON.stringify(ele_items);
        }
        fetch(`${routes.cart_add_url}`, config)
          .then((response) => response.json())
          .then((response) => {            
            if (response.status) {
              publish(PUB_SUB_EVENTS.cartError, {source: 'product-form', productVariantId: ele_formData.get('id'), errors: response.description, message: response.message});
              ele_this.handleErrorMessage(response.description);
              if (ele_this.cart && response.status == 422 && response.message.indexOf('added to your cart') > -1 ) {
                updateCartDrawer(ele_this);
              }
              const soldOutMessage = ele_this.submitButton.querySelector('.sold-out-message');
              if (!soldOutMessage) return;
              ele_this.submitButton.setAttribute('aria-disabled', true);
              ele_this.submitButton.querySelector('span').classList.add('hidden');
              soldOutMessage.classList.remove('hidden');
              ele_this.error = true;              
            } else if (response.errors) {
              publish(PUB_SUB_EVENTS.cartError, {source: 'product-form', productVariantId: ele_formData.get('id'), errors: response.errors, message: response.errors});
              ele_this.handleErrorMessage(response.errors);
              if (ele_this.cart && response.errors.indexOf('added to your cart') > -1 ) {
                updateCartDrawer(ele_this);
              }
              return;
            }
             else if (!ele_this.cart) {
              window.location = window.routes.cart_url;              
              return;
            }

            if (!ele_this.error) publish(PUB_SUB_EVENTS.cartUpdate, {source: 'product-form', productVariantId: ele_formData.get('id')});
            ele_this.error = false;            

            const quickAddModal = ele_this.closest('quick-add-modal');
            if (quickAddModal) {              
              document.body.addEventListener('modalClosed', () => {
                setTimeout(() => { ele_this.cart.renderContents(response) });
              }, { once: true });
              quickAddModal.hide(true);
              if( quickAddModal.getAttribute('data-recommanaed-pro') != null ){
                document.querySelector('.shopify-section.product-section product-recommended').remove();
              }
            } else {
              ele_this.cart.renderContents(response);
            }
          })
          .catch((e) => {
            console.error(e);
          })
          .finally(() => {
            ele_this.submitButton.classList.remove('loading');
            if (ele_this.cart && ele_this.cart.classList.contains('is-empty')) ele_this.cart.classList.remove('is-empty');
            if (!ele_this.error) ele_this.submitButton.removeAttribute('aria-disabled');
            ele_this.querySelector('.loading-overlay__spinner').classList.add('hidden');
          });
      }
      function updateCartDrawer(ele_this) {
        var section = ele_this.cart.getSectionsToRender().map((section) => section.id)
        fetch(window.location.pathname + '?sections='+section)
          .then(res => res.json())
          .then(data => {
            setTimeout(() => {
              const quickAddModal = ele_this.closest('quick-add-modal');
              if (quickAddModal) {              
                quickAddModal.hide(true);
                if( quickAddModal.getAttribute('data-recommanaed-pro') != null ){
                  document.querySelector('.shopify-section.product-section product-recommended').remove();
                }
              }
              ele_this.cart.renderContents(data, true); 
            }, 1250);            
          });
      }

      function createItem(ele_this, unique_vari_ids, items_object, properties){
        unique_vari_ids.forEach(( vari_id )=>{
          const vari_input_eles = product__outer.querySelectorAll('.quantity-box.length-active .fieldset_qty--wrapper[data-variant-id="'+vari_id+'"]')
          vari_input_eles.forEach((ele, index)=>{                  
            var temp_pro = {
              '_length_index': index
            };
            if( variant_metafields[vari_id] && variant_metafields[vari_id].max_qunatity != null ){
              temp_pro['_max-qty'] = Number(variant_metafields[vari_id].max_qunatity);
            }
            if( variant_metafields[vari_id] && variant_metafields[vari_id].min_qunatity != null ){
              temp_pro['_min-qty'] = variant_metafields[vari_id].min_qunatity;
            }            
            properties = { ...properties, ...temp_pro };
            items.push({
              id: Number(vari_id),
              quantity: ele.querySelector('.quantity__input').value,
              properties: properties
            })
          });
        })
        items_object['items'] = items;
        if (ele_this.cart) {
          items_object['sections'] = ele_this.cart.getSectionsToRender().map((section) => section.id);
          items_object['sections_url'] = window.location.pathname;          
        }
        console.log('items', items);
        callMainAddtoCart(ele_this, formData, config, items_object);
      }
    }

    handleErrorMessage(errorMessage = false) {
      if (this.hideErrors) return;

      this.errorMessageWrapper = this.errorMessageWrapper || this.querySelector('.product-form__error-message-wrapper');
      if (!this.errorMessageWrapper) return;
      this.errorMessage = this.errorMessage || this.errorMessageWrapper.querySelector('.product-form__error-message');

      this.errorMessageWrapper.toggleAttribute('hidden', !errorMessage);

      if (errorMessage) {
        this.errorMessage.textContent = errorMessage;
      }
    }
  });
}

function giftcardRecipient(){
  const giftCheckbox = document.querySelector('input[name="properties[__shopify_send_gift_card_to_recipient]"]');
  const recipientEmail = document.querySelector('input[name="properties[Recipient email]"]');
  const recipientName = document.querySelector('input[name="properties[Recipient name]"]');
  const yourName = document.querySelector('input[name="properties[Your Name]"]');
  const message = document.querySelector('textarea[name="properties[Message]"]');
  
  const recipientForm = document.querySelector('recipient-form');    
  
  if (giftCheckbox.checked) {    
    let isValid = true;
    const errors = {};
    
    if (!recipientEmail.value.trim()) {
      errors.email = ['This field is required'];
      isValid = false;
    } else if (!isValidEmail(recipientEmail.value)) {
      errors.email = ['Invalid email format'];
      isValid = false;
    }
    
    if (!recipientName.value.trim()) {
      errors.name = ['This field is required'];
      isValid = false;
    }
    
    if (!yourName.value.trim()) {
      errors['your-name'] = ['This field is required'];
      isValid = false;
    }
    
    if (Object.keys(errors).length > 0) {
      recipientForm.displayErrorMessage('Please fix the following errors:', errors);
    }
    
    if (!isValid) {      
      return false;
    }
  }
  return true;
}

function isValidEmail(email) {
  const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
  return emailRegex.test(email);
}